import React, { useState, useEffect } from "react";
import Message from "../components/Message";
import QrReader from "react-qr-reader";
import { Button, Row, Col, ListGroup, Image, Card } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { createOrder } from "../actions/orderActions";
import backend from "../api";
import { ORDER_CREATE_RESET } from "../constants/orderConstants.js";
import { useHistory } from "react-router";
import { formatPrice } from "../utils/formatPrice.js";
import Loader from "../components/Loader.js";

const CreateOrder = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});
  const [state, setState] = useState(true);
  const [userId, setUserId] = useState(null);
  const [salesTax, setSalesTax] = useState(0);
  const [participatingSalesTax, setParticipatingSalesTax] = useState(0);
  const [nonParticipatingSalesTax, setNonParticipatingSalesTax] = useState(0);
  const userLogin = useSelector((state) => state.userLogin);
  const { order, error } = useSelector((state) => state.order);
  const { userInfo } = userLogin;
  const [memberDetail, setMemberDetail] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [memberError, setMemberError] = useState(null);

  useEffect(() => {
    const fetchTaxValues = async () => {
      try {
        const { data } = await backend.get("/amounts");
        if (data.length > 0) {
          setParticipatingSalesTax(data[0].ParticipatingSalesTax);
          setNonParticipatingSalesTax(data[0].NonParticipatingSalesTax);
        }
      } catch (err) {
        console.error("Error fetching tax values", err);
      }
    };

    fetchTaxValues();
  }, []);

  const findFormErrors = () => {
    const { total_price } = form;
    const newErrors = {};
    if (!total_price || total_price === "")
      newErrors.total_price = "this field is required";
    return newErrors;
  };

  const setField = (field, value) => {
    setForm({
      ...form,
      [field]: value,
    });
    if (!!errors[field])
      setErrors({
        ...errors,
        [field]: null,
      });
  };

  const submitHandler = (e) => {
    e.preventDefault();
    const newErrors = findFormErrors();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      const tax_charges = userInfo?.participating_merchant
        ? participatingSalesTax
        : nonParticipatingSalesTax;
      const percentage = (form.total_price * tax_charges) / 100;
      const tax = percentage;
      setSalesTax(tax);
      setState(false);
      dispatch({ type: ORDER_CREATE_RESET });
    }
  };

  const handleError = (err) => {
    console.error(err);
  };

  const getUserDetails = async (id) => {
    setIsLoading(true);
    setMemberError(null);
    try {
      const { data } = await backend.get("/user", { params: { _id: id } });
      if (data?.data?.[0]) {
        setMemberDetail(data.data[0]);
      } else {
        setMemberError("No member details found for the scanned ID.");
      }
    } catch (error) {
      console.error("Error fetching member details: ", error);
      setMemberError("Failed to retrieve member details. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleScan = (data) => {
    if (data) {
      setUserId(data);
      getUserDetails(data);
    }
  };

  useEffect(() => {
    if (order) {
      history.push(`/order/${order.data._id}`);
      dispatch({ type: ORDER_CREATE_RESET });
    }
  }, [order, history, dispatch]);

  const placeOrderHandler = () => {
    let orderData = {
      merchant: userInfo._id,
      customer: userId,
      total_price: Number(form.total_price) + Number(salesTax),
      total_sales_tax: salesTax,
      order_note: form.order_note ? form.order_note : null,
    };
    dispatch(createOrder(orderData));
  };

  const changeAmount = () => {
    setForm({});
    setState(true);
    setUserId(null);
  };

  return (
    <Card>
      <div>
        {state ? (
          <>
            <Row>
              <Col md={9} lg={9} xs={12}>
                <ListGroup variant="flush">
                  <ListGroup.Item style={{ color: "black" }}>
                    <div className="col-lg-6 col-md-12">
                      <h3>Add Amount</h3>
                      <div>
                        <form onSubmit={submitHandler}>
                          <div>
                            <label htmlFor="total_price">
                              Add total amount without tax.
                            </label>
                            <input
                              type="number"
                              className="form-control mb-0"
                              id="total_price"
                              name="total_price"
                              placeholder="Enter number"
                              onChange={(e) =>
                                setField("total_price", e.target.value)
                              }
                              isInvalid={!!errors.total_price}
                            />
                            <div className="error">
                              {errors.total_price && errors.total_price}
                            </div>
                          </div>
                          <button
                            type="submit"
                            variant="danger"
                            className="btn btn-danger"
                          >
                            Submit
                          </button>
                        </form>
                      </div>
                    </div>
                  </ListGroup.Item>
                </ListGroup>
              </Col>
              <Col md={3}></Col>
            </Row>
          </>
        ) : (
          <>
            <Row>
              <Col md={5} lg={5} xs={12}>
                <br />
                <Button
                  type="button"
                  className="btn-danger mx-3"
                  onClick={changeAmount}
                >
                  Change Total Amount
                </Button>
                <br />

                <ListGroup variant="flush">
                  <ListGroup.Item>
                    {userId ? (
                      <div>
                        <h4>Scanned Customer</h4>
                        {isLoading ? (
                          <div className="d-flex mt-3">
                            <Loader />
                          </div>
                        ) : memberError ? (
                          <Message variant="danger">{memberError}</Message>
                        ) : (
                          <div className="d-flex flex-column mt-3">
                            <h6>
                              {`${memberDetail?.first_name} ${memberDetail?.last_name}`}
                            </h6>
                            <span>
                              <strong>Email: </strong> {memberDetail?.email}
                            </span>
                            <span>
                              <strong>Phone: </strong> {memberDetail?.phone}
                            </span>
                          </div>
                        )}
                      </div>
                    ) : (
                      <QrReader
                        facingMode={"user"}
                        delay={300}
                        onError={(err) => handleError(err)}
                        onScan={(data) => {
                          handleScan(data);
                        }}
                        style={{ width: "100%" }}
                      />
                    )}
                  </ListGroup.Item>
                </ListGroup>
              </Col>
              <Col md={1} lg={1}></Col>

              <Col md={5} lg={5} xs={12}>
                <br />
                <Card>
                  <ListGroup variant="flush">
                    <ListGroup.Item style={{ color: "black" }}>
                      <h2>Order Summary</h2>
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <Row>
                        <Col>
                          <h6>Sub Total</h6>
                        </Col>
                        <Col>
                          <h5>{formatPrice(form.total_price)}</h5>
                        </Col>
                      </Row>
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <Row>
                        <Col>
                          <h6>Sales Tax</h6>
                        </Col>
                        <Col>
                          <h5>{formatPrice(salesTax)}</h5>
                        </Col>
                      </Row>
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <Row>
                        <Col>
                          <h6>Total</h6>
                        </Col>
                        <Col>
                          <h5>
                            {formatPrice(
                              Number(form.total_price) + Number(salesTax)
                            )}
                          </h5>
                        </Col>
                      </Row>
                    </ListGroup.Item>

                    <ListGroup.Item>
                      <Row className="justify-content-center">
                        <input
                          type="text"
                          placeholder="Enter note"
                          className="form-control mb-0"
                          onChange={(e) =>
                            setField("order_note", e.target.value)
                          }
                        />
                      </Row>
                    </ListGroup.Item>
                    <ListGroup.Item>
                      {error && <Message variant="danger">{error}</Message>}
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <Button
                        disabled={!userId || !memberDetail || !memberDetail._id}
                        type="button"
                        className="btn-danger"
                        onClick={placeOrderHandler}
                      >
                        Place Order
                      </Button>
                    </ListGroup.Item>
                  </ListGroup>
                </Card>
              </Col>
            </Row>
            <br />
          </>
        )}
      </div>
    </Card>
  );
};

export default CreateOrder;
